function initMlvImageSliders(root = document) {
  root.querySelectorAll('.mlv-image-slider').forEach((slider) => {
    if (slider.dataset.mlvInitialized === 'true') return;
    slider.dataset.mlvInitialized = 'true';

    const track = slider.querySelector('.mlv-slider-track');
    const slides = Array.from(slider.querySelectorAll('.mlv-slide'));
    const prevBtn = slider.querySelector('.mlv-prev');
    const nextBtn = slider.querySelector('.mlv-next');
    const mainImageWrapper = slider.closest('.mlv-product-card')?.querySelector('.product-card__image--main') || slider.closest('.mlv-product-card-homepage')?.querySelector('.product-card__image--main');
    const mainImageContainerWrapper = mainImageWrapper.closest(".product-card__image-wrapper");
    const mainImage = mainImageWrapper?.querySelector('img');

    let currentOffset = 0;

    function scrollThumbIntoView(slide) {
      const viewport = slider.querySelector('.mlv-slider-viewport');
      const viewportWidth = viewport.offsetWidth;

      // Pure DOM positioning (NOT affected by transform)
      const slideLeft = slide.offsetLeft;
      const slideWidth = slide.offsetWidth;

      // Center slide in viewport
      const targetOffset =
        slideLeft - (viewportWidth / 2) + (slideWidth / 2);

      const trackWidth = track.scrollWidth;
      const maxOffset = 0;
      const minOffset = -(trackWidth - viewportWidth);

      currentOffset = -targetOffset;
      currentOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));

      track.style.transform = `translateX(${currentOffset}px)`;

      prevBtn?.classList.toggle('is-hidden', currentOffset >= maxOffset - 1);
      nextBtn?.classList.toggle('is-hidden', currentOffset <= minOffset + 1);
    }





    /* -------- Update -------- */
    function update(directionRight = true) {
      if (directionRight) {
        currentOffset -= 100;
      } else {
        currentOffset += 100;
      }

      const viewportWidth = slider.querySelector('.mlv-slider-viewport').offsetWidth;
      const trackWidth = track.scrollWidth;
      const maxOffset = 0;
      const minOffset = -(trackWidth - viewportWidth);

      currentOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
      track.style.transform = `translateX(${currentOffset}px)`;

      prevBtn?.classList.toggle('is-hidden', currentOffset >= maxOffset - 1);
      nextBtn?.classList.toggle('is-hidden', currentOffset <= minOffset + 1 || trackWidth <= viewportWidth);
    }

    /* -------- FIXED Thumbnail Click -------- */
    slides.forEach((slide) => {
      slide.addEventListener('mouseenter', () => {
        const thumbImg = slide.querySelector('img');
        if (!thumbImg || !mainImage || !mainImageWrapper) return;

         const hoverImage = slide.closest(".product-card__wrapper")?.querySelector(".product-card__image.product-card__image--second img");

        const getPath = (url) => new URL(url, location.origin).pathname;

        if (
          hoverImage &&
          getPath(hoverImage.src) === getPath(thumbImg.src)
        ) {
          mainImageContainerWrapper.classList.add("mlv-skip-img");
        } else {
          mainImageContainerWrapper.classList.remove("mlv-skip-img");
        }
        // if((thumbImg.src.toLowerCase().includes('lifestyleimages') || thumbImg.src.toLowerCase().includes('lifestyle')) && mainImageContainerWrapper){
        //   mainImageContainerWrapper.classList.add("mlv-skip-img");
        // }
        // else{
        //   mainImageContainerWrapper.classList.remove("mlv-skip-img");

        // }

        // ✅ Scroll thumbnail into view
        // scrollThumbIntoView(slide);

        // 🔥 COMPLETE LAZY LOADING BYPASS
        const newSrc = thumbImg.src;

        const tempImg = new Image();
        tempImg.onload = () => {
          mainImage.src = newSrc;
          mainImage.srcset = '';
          mainImage.alt = thumbImg.alt;

          mainImage.removeAttribute('loading');
          mainImage.removeAttribute('data-src');
          mainImage.removeAttribute('data-srcset');
          mainImage.removeAttribute('is');
          mainImage.removeAttribute('sizes');
          mainImage.classList.remove('image-lazy', 'motion-reduce', 'lazyload');

          mainImage.style.opacity = '0.5';
          mainImage.offsetHeight;
          mainImage.style.opacity = '1';
        };
        tempImg.src = newSrc;

        slides.forEach((s) => s.classList.remove('is-active'));
        slide.classList.add('is-active');
      });
    });


    prevBtn?.addEventListener('click', () => update(false));
    nextBtn?.addEventListener('click', () => update(true));

    slider.addEventListener('wheel', (e) => {
      e.preventDefault();
      if (e.deltaY > 0) update(true);
      if (e.deltaY < 0) update(false);
    }, { passive: false });

    // Initial button states
    requestAnimationFrame(() => {
      const viewportWidth = slider.querySelector('.mlv-slider-viewport').offsetWidth;
      const trackWidth = track.scrollWidth;

      currentOffset = 0;
      track.style.transform = `translateX(0px)`;
      prevBtn?.classList.add('is-hidden');

      if (trackWidth <= viewportWidth) {
        nextBtn?.classList.add('is-hidden');
      } else {
        nextBtn?.classList.remove('is-hidden');
      }
    });
  });
}

// DOMContentLoaded handler stays the same
document.addEventListener('DOMContentLoaded', () => {
  const isProductPage = document.body.classList.contains('product-template') ||
    document.body.classList.contains('template-product');

  setTimeout(() => initMlvImageSliders(), 200);
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.('.mlv-image-slider')) {
          initMlvImageSliders(node.parentElement);
        }
        if (node.querySelector?.('.mlv-image-slider')) {
          initMlvImageSliders(node);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  //                       if (isProductPage) {
  // } else {
  //   initMlvImageSliders();
  // }
});

